import React, { useEffect, useState } from 'react'
import { Tabs } from 'antd'
import POSService from '../../core/services/POSService'
import ConfirmModal from '../components/modal/ConfirmModal'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { formatPrice } from '../../core/utils/formatter'
import { useNavigate } from 'react-router-dom'
import { convertToUTC7, generatePosReference } from '../../util/util'
import withReactContent from 'sweetalert2-react-content'
import PaymentComponent from './payment/paymentComponent'
import Swal from 'sweetalert2'
import ImageWithBasePath from '../../components/general/ImageCustom'
const CustomTab = ({
  orderBySession,
  sessionId,
  activeKeyPos,
  showCompletePayment,
  openModal,
  keyDelete,
  orderList,
  orderDetail,
  paymentMethod,
  selectedTable,
  methodSelect,
  showChooseMethod,
  setOrderBySession,
  posId,
  posSession,
  posContext,
  posMachines,
  updateCustomerInvoice,
  handleComletePaymentWithQR,
  refetchOrderBySession,
  handleCompletePayment,
  handleCloseCompletePayment,
  handleOpenPrintReceipt,
  setSelectedCustomer,
  handleShowQR,
  handleCloseChooseMethod,
  handleChooseMethod,
  updateOrderInvoice,
  setOrderList,
  setOrderDetail,
  setLoadingOrderDetail,
  setOpenModal,
}) => {
  const { t } = useTranslation()
  const [activeKey, setActiveKey] = useState(activeKeyPos)
  const [items, setItems] = useState([])
  const [hiddenTabIds, setHiddenTabIds] = useState([]) // Track hidden paid invoices
  const navigate = useNavigate()
  const [showQR, setShowQR] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }
  const MySwal = withReactContent(Swal)

  const showConfirmationAlertCheckout = () => {
    MySwal.fire({
      title: t('confirm_checkout'),

      showCancelButton: true,
      confirmButtonColor: '#00ff00',
      confirmButtonText: t('confirm_yes'),
      cancelButtonColor: '#ff0000',
      cancelButtonText: t('confirm_no'),
    }).then((result) => {
      if (result.isConfirmed) {
        handleCompletePayment().then((res) => {
          if (res) {
            addNewOrder()
          }
        })
      } else {
        MySwal.close()
      }
    })
  }

  useEffect(() => {
    if (orderBySession.length > 0 && !selectedTable) {
      const paidInvoiceIds = orderBySession?.records
        ?.filter((invoice) => invoice.state === 'paid')
        .map((invoice) => invoice.id)
      setHiddenTabIds(paidInvoiceIds)
      const temp = orderBySession?.records
        ?.filter((invoice) => invoice.state === 'draft')
        .map((invoice) => ({ key: invoice.id, label: `${t('invoice')} ${invoice.id} ` }))
      setActiveKey(temp[0]?.key)
      onChange(temp[0]?.key)

      setItems(temp || [])
    }
    if (activeKeyPos) {
      setActiveKey(activeKeyPos)
    }
  }, [orderBySession, activeKeyPos])

  useEffect(() => {
    const temp = orderBySession?.records
      ?.filter((invoice) => !hiddenTabIds.includes(invoice.id))
      .map((invoice) => ({
        key: invoice.id,
        label: `${t('invoice')} ${invoice.id} `,
      }))
    setItems(temp || [])
  }, [hiddenTabIds, setHiddenTabIds])

  const onChange = async (newActiveKey) => {
    console.log(newActiveKey, 'newActiveKey')
    if (!newActiveKey) {
      return
    }
    setActiveKey(newActiveKey)
    setLoadingOrderDetail(true)
    const orderDetail = await POSService.getOrderDetail(newActiveKey)
    if (orderDetail.length > 0 && orderDetail[0]?.lines && orderDetail[0].lines?.length >= 0) {
      const { lines, ...rest } = orderDetail[0]
      setOrderList(lines)
      setOrderDetail(rest)
      updateOrderInvoice(lines, newActiveKey)
      updateCustomerInvoice(null)
      setSelectedCustomer(null)
    }
    setLoadingOrderDetail(false)
  }

  // Show a specific invoice tab
  const showTabById = (id) => {
    setHiddenTabIds((prev) => prev.filter((tabId) => tabId !== id))
  }

  const addNewOrder = async () => {
    const bodyNewOrder = {
      session_id: sessionId,
      amount_tax: 0,
      amount_total: 0,
      amount_paid: 0,
      amount_return: 0,
      sequence_number: orderBySession.length + 1,
      pos_reference: `Order ${generatePosReference(posSession?.id, posSession?.login_number, orderBySession.length + 1)}`,
    }

    if (selectedTable) {
      bodyNewOrder.table_id = selectedTable
    }

    await POSService.newOrder(bodyNewOrder).then(async (res) => {
      const newActiveKey = res[0]
      const newPanes = [...items]
      await onChange(newActiveKey)
      newPanes.push({
        label: `${t('invoice')} ${newActiveKey}`,
        key: newActiveKey,
      })
      setItems(newPanes)
      setActiveKey(newActiveKey)
    })
    await POSService.getOrderBySession(sessionId).then((res) => {
      setOrderBySession(res)
    })
  }

  const remove = async (targetKey) => {
    let newActiveKey = activeKey
    let lastIndex = -1
    items.forEach((item, i) => {
      if (item.key === targetKey) {
        lastIndex = i - 1
      }
    })
    const newPanes = items.filter((item) => item.key !== targetKey)
    if (newPanes.length && newActiveKey === targetKey) {
      if (lastIndex >= 0) {
        newActiveKey = newPanes[lastIndex].key
      } else {
        newActiveKey = newPanes[0].key
      }
    }

    setItems(newPanes)
    setActiveKey(newActiveKey)
    onChange(newActiveKey)
  }

  const handleViewOrder = async (orderId) => {
    onChange(orderId)
  }

  const onEdit = async (targetKey, action) => {
    if (action === 'add') {
      addNewOrder()
    } else {
      remove(targetKey)
    }
  }

  const confirmModal = async () => {
    await POSService.deleteOrder(keyDelete)
    remove(keyDelete)
    setOpenModal(false)
    refetchOrderBySession()
    if (selectedTable) {
      navigate(`/pos/${posId}`)
    }
  }

  let totalPaymentAmount = orderList?.reduce((sum, item) => sum + item.price_subtotal_incl, 0)

  return (
    <>
      {!selectedTable && !posContext.selected_table && (
        <Tabs
          tabBarStyle={{
            margin: 1,
            height: 60,
            backgroundColor: '#E8E9EC',
            borderRadius: '16px',
            fontSize: '16px',
            fontWeight: 500,
            color: '#262626',
            border: 'none',
          }}
          type='editable-card'
          onChange={onChange}
          activeKey={activeKey}
          onEdit={onEdit}
          items={items}
        />
      )}

      <ConfirmModal
        title={t('confirm_delete_draft_invoice')}
        content={t('content_delete_draft_invoice')}
        onOkFunc={confirmModal}
        onCancelFunc={() => setOpenModal(false)}
        open={openModal}
        textCancel={t('cancel')}
        textOk={t('Delete')}
      />

      <Modal
        show={showCompletePayment}
        onHide={handleCloseCompletePayment}
        centered
        id='payment-completed'
        aria-labelledby='payment-completed'
      >
        <Modal.Header>
          <Modal.Title id='payment-method-modal'>{t('complete_payment')}</Modal.Title>{' '}
          <button
            type='button'
            className='close'
            data-bs-dismiss='modal'
            data-bs-target='payment-completed'
            aria-label='Close'
            onClick={handleCloseCompletePayment}
          >
            <span aria-hidden='true'>×</span>
          </button>
        </Modal.Header>

        <Modal.Body className='text-center'>
          <form>
            <div className='flex items-center justify-center text-green-500'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='h-24 w-24'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              >
                <path d='M22 11.08V12a10 10 0 1 1-5.93-9.14'></path>
                <polyline points='22 4 12 14.01 9 11.01'></polyline>
              </svg>
            </div>
            <div className='modal-footer d-sm-flex justify-content-between'>
              <button type='button' className='btn btn-primary flex-fill me-1' onClick={handleCloseCompletePayment}>
                {t('next_order')}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <div className='modal fade pos-modal' id='orders' tabIndex={-1} aria-hidden='true'>
        <div className='modal-dialog modal-md modal-dialog-centered' role='document'>
          <div className='modal-content'>
            <div className='modal-header p-4'>
              <h5 className='modal-title'>{t('orders')}</h5>
              <button type='button' className='close' data-bs-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>×</span>
              </button>
            </div>
            <div className='modal-body p-4'>
              <div className='tabs-sets'>
                <h3 style={{ marginBottom: '10px' }}>
                  {t('total_orders')} : {orderBySession?.records?.filter((item) => item.state !== 'draft').length}
                </h3>
                <div className='tab-content'>
                  <div className='order-body'>
                    {orderBySession?.records
                      ?.filter((item) => item.state !== 'draft')
                      .map((item) => (
                        <div className='default-cover mb-4 p-4' key={item?.id}>
                          <span className='badge d-inline-block bold mb-4 bg-primary'>
                            {t('Order')} : # {item?.id}
                          </span>
                          <div className='row'>
                            <div className='col-sm-12 col-md-6 record mb-3'>
                              <table>
                                <tbody>
                                  <tr className='mb-3'>
                                    <td>{t('shop')}</td>
                                    <td>:</td>
                                    <td className='text'>{item?.config_id.display_name}</td>
                                  </tr>
                                  <tr>
                                    <td>{t('customer')}</td>
                                    <td>:</td>
                                    <td className='text'>{item?.partner_id.display_name}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className='col-sm-12 col-md-6 record mb-3'>
                              <table>
                                <tbody>
                                  <tr>
                                    <td>{t('date')}</td>
                                    <td>:</td>
                                    <td className='text'>{convertToUTC7(item?.date_order)}</td>
                                  </tr>
                                  <tr>
                                    <td>{t('state')}</td>
                                    <td>:</td>
                                    <td className='text'>{t(`${item?.state}`)}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div className='btn-row d-flex align-items-center justify-content-between'>
                            <Link
                              to='#'
                              className='btn btn-info btn-icon flex-fill'
                              onClick={(e) => {
                                e.preventDefault()
                                showTabById(item?.id)
                                handleViewOrder(item?.id)
                              }}
                              data-bs-dismiss='modal'
                            >
                              {t('open')}
                            </Link>
                            <Link
                              to='#'
                              className='btn btn-success btn-icon flex-fill'
                              onClick={(e) => {
                                e.preventDefault()
                                handleViewOrder(item?.id)
                                handleOpenPrintReceipt()
                              }}
                            >
                              {t('print')}
                            </Link>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* payment method modal */}
      <Modal
        show={showChooseMethod}
        onHide={handleCloseChooseMethod}
        centered
        id='payment-method-modal'
        aria-labelledby='payment-method-modal'
      >
        <Modal.Header>
          <Modal.Title id='payment-method-modal'>{t('payment_method')}</Modal.Title>
          <button
            type='button'
            className='close'
            data-bs-dismiss='modal'
            aria-label='Close'
            onClick={() => {
              handleCloseChooseMethod()
            }}
          >
            <span aria-hidden='true'>×</span>
          </button>
        </Modal.Header>
        <Modal.Body>
          {/* PAYMENT INFO */}

          <div className='mx-auto mb-4 inline-flex w-full max-w-2xl flex-col items-center justify-start gap-3 rounded-xl border border-[#e8e8e8] bg-white p-3'>
            <div className='relative h-[120px] w-[120px] overflow-hidden'>
              <ImageWithBasePath src='assets/img/POS/payment_img.svg' alt='' />
            </div>
            <div className='inline-flex items-start justify-between self-stretch'>
              <div className="font-['Inter Display'] text-base font-normal leading-normal text-[#525866]">
                {t('provisional')}
              </div>
              <div className="font-['Inter Display'] text-base font-medium leading-normal text-[#0e121b]">
                {orderList?.length > 0 && orderDetail?.currency_id?.display_name
                  ? formatPrice(
                      orderList?.reduce((sum, item) => sum + item.price_subtotal, 0),
                      orderDetail?.currency_id?.display_name
                    )
                  : '0'}
              </div>
            </div>
            <div className='inline-flex items-start justify-between self-stretch'>
              <div className="font-['Inter Display'] text-base font-normal leading-normal text-[#525866]">
                {t('tax')}
              </div>
              <div className="font-['Inter Display'] text-base font-medium leading-normal text-[#0e121b]">
                {orderList?.length > 0 && orderDetail?.currency_id?.display_name
                  ? formatPrice(
                      orderList?.reduce((sum, item) => sum + (item.price_subtotal_incl - item.price_subtotal), 0),
                      orderDetail?.currency_id?.display_name
                    )
                  : '0'}
              </div>
            </div>
            <div className='inline-flex items-start justify-between self-stretch'>
              <div className="font-['Inter Display'] text-lg font-normal leading-normal text-[#0e121b]">
                {t('total')}
              </div>
              <div className="font-['Inter Display'] text-lg font-semibold leading-normal text-[#28c76f]">
                {orderList?.length > 0 && orderDetail?.currency_id?.display_name
                  ? formatPrice(
                      orderList?.reduce((sum, item) => sum + item.price_subtotal_incl, 0),
                      orderDetail?.currency_id?.display_name
                    )
                  : '0'}
              </div>
            </div>
          </div>

          {/* PAYMENT METHOD */}
          <div className='mx-auto inline-flex w-full max-w-2xl flex-col items-center justify-start gap-3 rounded-xl border border-[#e8e8e8] bg-white p-3'>
            <div className='inline-flex items-center justify-between self-stretch'>
              <div className="font-['Inter Display'] text-base font-semibold leading-normal text-[#0e121b]">
                Phương thức thanh toán
              </div>
              <div className='relative'>
                <div
                  className='flex cursor-pointer items-center justify-start gap-3 rounded-lg border border-[#e8e8e8] bg-white px-3 py-1.5'
                  onClick={toggleDropdown}
                >
                  <div className='flex items-center justify-start gap-2 self-stretch'>
                    <div className='flex h-6 w-6 items-center justify-center'>
                      <ImageWithBasePath src='assets/img/POS/card.svg' alt='' />
                    </div>
                    <div className="font-['Inter Display'] text-sm font-normal leading-tight text-[#0e121b]">
                      {t(methodSelect?.name)}
                    </div>
                    <div
                      className={`flex h-4 w-4 transform items-center justify-center transition-transform ${isOpen ? 'rotate-180' : ''}`}
                    >
                      <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <g id='vuesax/bold/arrow-down'>
                          <g id='arrow-down'>
                            <path
                              id='Vector'
                              d='M11.9465 5.45337H7.79316H4.05317C3.41317 5.45337 3.09317 6.2267 3.5465 6.68004L6.99983 10.1334C7.55317 10.6867 8.45317 10.6867 9.0065 10.1334L10.3198 8.82004L12.4598 6.68004C12.9065 6.2267 12.5865 5.45337 11.9465 5.45337Z'
                              fill='#525866'
                            />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
                {isOpen && (
                  <div className='absolute left-0 z-10 mt-2 w-full rounded-lg border border-[#e8e8e8] bg-white shadow-lg'>
                    <ul className='flex flex-col py-2'>
                      {paymentMethod?.length > 0 &&
                        paymentMethod.map((method) => (
                          <li
                            className='cursor-pointer px-4 py-2 hover:bg-gray-100'
                            onClick={() => {
                              handleChooseMethod(method)
                              setShowQR(false) // Reset QR visibility when method
                              toggleDropdown()
                            }}
                          >
                            {t(method?.name)}
                          </li>
                        ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>

            {methodSelect && (
              <>
                {' '}
                {methodSelect?.type == 'bank' ? (
                  <PaymentComponent
                    orderId={orderDetail.id}
                    handleShowQR={handleShowQR}
                    posMachines={posMachines}
                    addNewOrder={addNewOrder}
                    orderDetail={orderDetail}
                    totalPaymentAmount={totalPaymentAmount}
                    handleComletePaymentWithQR={handleComletePaymentWithQR}
                    posId={posId}
                  />
                ) : (
                  <div
                    className='flex flex-col items-start justify-start gap-4 self-stretch overflow-hidden rounded-2xl border border-neutral-200 bg-white p-3 transition-all duration-300 hover:scale-[1.02] hover:cursor-pointer hover:shadow-lg'
                    onClick={async (e) => {
                      e.preventDefault()
                      showConfirmationAlertCheckout()
                    }}
                  >
                    <div className='inline-flex items-center justify-start gap-2 self-stretch'>
                      <div className='inline-flex h-9 w-9 flex-col items-center justify-center gap-[6.43px] overflow-hidden rounded-[10.29px] bg-[#28c76f]/10'>
                        <div className='relative h-6 w-6'>
                          <svg
                            width='24'
                            height='24'
                            viewBox='0 0 24 24'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              id='Vector'
                              d='M0 12C0 5.37208 5.37262 0 11.9998 0C18.6274 0 24 5.37213 24 12C24 18.6272 18.6274 23.9998 11.9998 23.9998C5.37262 23.9998 0 18.6272 0 12Z'
                              fill='#28C76F'
                            />
                          </svg>
                          <div className='absolute left-[5px] top-[5px] inline-flex h-3.5 w-3.5 items-center justify-center'>
                            <ImageWithBasePath src='assets/img/POS/white-card.svg' alt='' />
                          </div>
                        </div>
                      </div>
                      <div className="font-['Inter Display'] text-base font-medium leading-normal text-[#424653]">
                        {t('checkout')}
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default CustomTab
